import { Component, Input } from '@angular/core';
import { SocialMediaData } from '@evermile/customer-tracking';

@Component({
  selector: 'common-promotion-instagram-link',
  templateUrl: './promotion-instagram-link.component.html',
  styleUrls: ['./promotion-instagram-link.component.scss'],
})
export class PromotionInstagramLinkComponent {
  @Input({ required: true }) instagramPromotionData!: SocialMediaData;

  ngAfterViewInit() {
    window.addEventListener('message', (e) => this.receiveMessage(e), false);
  }

  receiveMessage(event: MessageEvent) {
    if (event.origin === 'https://www.instagram.com') {
      const data = JSON.parse(event.data);
      if (data?.details?.height) {
        this.resizeInstagramIframe(data.details.height);
      }
    }
  }

  resizeInstagramIframe(height: number) {
    const IframeElement = document.querySelector('#instagram-promotion') as HTMLDivElement;
    const IframeWrapperElement = document.querySelector('.iframe-wrapper') as HTMLDivElement;
    if (IframeElement && IframeWrapperElement) {
      const newHeight = `${Math.max(380, height + 20)}px`;
      IframeElement.style.height = newHeight;
      IframeWrapperElement.style.height = newHeight;
    }
  }
}
